import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { useSeo, Reveal, Icon, LazyImg } from "../components/common";
import { PageHero } from "../components/PageHero";
import { CTABand } from "../components/blocks";
import { INDUSTRIES, IMG } from "../data/site";

export default function Industries() {
  const { t, lang } = useLang();
  useSeo("Industries We Serve | Sparko Netherlands", "Sparko provides tailored professional cleaning for offices, schools, hospitals, hotels, restaurants, warehouses, factories, retail and more across the Netherlands.");
  return (
    <div>
      <PageHero title="Industries We Serve" crumb={t.nav.industries} bg={IMG.office4}
        sub="Choose the type of building or industry you need cleaned — Sparko tailors its cleaning services to every sector across the Netherlands." />
      <section className="mx-auto max-w-7xl px-5 md:px-8 py-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.en} delay={(i % 3) * 0.08}>
              <Link to={`/services?cat=${ind.cat}`} className="group relative block overflow-hidden rounded-3xl aspect-[4/3] hover-lift" data-testid={`industry-${ind.en}`}>
                <LazyImg src={IMG[ind.img]} alt={ind[lang]} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="grid place-items-center h-11 w-11 rounded-2xl glass text-blue"><Icon name={ind.icon} size={20} /></div>
                    <h3 className="font-display text-xl text-white">{ind[lang]}</h3>
                  </div>
                  <Icon name="ArrowUpRight" size={22} className="text-white/70 group-hover:text-white transition-colors" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
